import { render, staticRenderFns } from "./MSPK.vue?vue&type=template&id=4d0a47e4&scoped=true"
import script from "./MSPK.vue?vue&type=script&lang=js"
export * from "./MSPK.vue?vue&type=script&lang=js"
import style0 from "./MSPK.vue?vue&type=style&index=0&id=4d0a47e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a47e4",
  null
  
)

export default component.exports